import React, { Fragment } from 'react';
import { connect, Provider } from 'react-redux';

import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';
import { TextField, WithStyles } from '@material-ui/core';

import { AppState, Actions, store } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import { ThemeProvider } from '@material-ui/core/styles';
import CONFIG from '../../cfg/config';
import { ReservationId, bookService, Info, UserData } from '../../api';
import ReactDOM from 'react-dom';
import DialogEnd from './End';
import themeDialog from '../../themes-dialog';

import { outerTheme } from '../../themes';
import { sendErrorLog, wciecie } from '../common/helpers';

//PM 2021-11-25
//wstrzykniecie tylko uzywanych pol z magazynu danych
type ZamInfoErrorProps = {
    randomNum: number,
    //message: string,
    data: {
        distance: string;
        distanceClient: string;
    },

}

//PM 2021-11-25
type ZamInfoErrorState = {
    open: boolean,
}

class ZamInfoError extends React.Component<ZamInfoErrorProps & WithStyles<typeof styles>, ZamInfoErrorState> {
    stylInputaRezerwacja: React.CSSProperties = { padding: "8px 14px", textAlign: "left", fontWeight: "bold", fontSize: "1rem" };

    constructor(props: ZamInfoErrorProps & WithStyles<typeof styles>) {
        super(props, {});

        this.state = {
            open: true,
        };
    }

    componentDidUpdate(prevProps: ZamInfoErrorProps) {
        if(this.props.randomNum !== prevProps.randomNum){
            this.setState({open: true})
        }
    }

    // componentDidUpdate(prevProps: ZamInfoErrorProps) {
    //     if (this.props.dialogSms !== prevProps.dialogSms) {
    //         this.setState({ open: true} )
    //         this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "white" };
    //     }

    // }

    close = () => {
        this.setState({ open: false })
    };

    //PM 2021-11-25
    //onClick={this.confirmZamInfoError}
    render() {
        const { classes } = this.props;

        return (
            // <Fragment>
            //     <Dialog
            //         disableEscapeKeyDown
            //         maxWidth="xs"
            //         fullWidth
            //         open={this.state.open}
            //     >
            //         {
            //         <Fragment>
                        <Dialog
                        disableEscapeKeyDown
                        maxWidth="xs"
                        fullWidth
                        open={this.state.open}>

                        <DialogTitle disableTypography>
                            <Typography gutterBottom variant="h5" component="h2" color="error" style={{ fontSize: "1.25rem" }}>
                            <b>przepraszamy</b>
                            </Typography>
                            <hr />
                        </DialogTitle>
                        <DialogContent className={classes.dialogContent}>
                            <Typography gutterBottom variant="h5" component="h2" color="textSecondary">
                                Nie możemy przyjąć zamówienia
                            </Typography>
                            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
                             <b className={classes.secondary}></b>
                            </Typography>
                            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
                            {wciecie + 'dowóz zamówień realizujemy w obrebie:'} <b className={classes.secondary}>{this.props.data.distance}</b>
                            </Typography>
                            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
                            {wciecie + 'twój adres jest w odległości:'} <b className={classes.secondary}>{this.props.data.distanceClient}</b>
                            </Typography>
                            {/* <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
                            {wciecie + 'termin:'} <b className={classes.secondary}>{this.props.data.date}</b>
                            </Typography> */}
                            {/* <Typography gutterBottom variant="h5" component="h2" className={classes.padding} color="textSecondary">
                            {wciecie + 'dlaczego:'} <b className={classes.secondary}>{this.props.message}</b>
                            </Typography> */}
                        </DialogContent >
                        <DialogActions >
                            <ThemeProvider theme={outerTheme}>
                            <Button onClick={this.close} variant="outlined" size="small" color="secondary"
                                style={{ textTransform: "none", fontSize: "0.8rem" }}
                            >
                                <b><Trans>OK</Trans></b>
                            </Button>
                            </ThemeProvider>
                        </DialogActions>
                        </Dialog>
            //         </Fragment>
            //         }
            //     </Dialog>
            // </Fragment>
        )

    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    primaryBold: {
        color: theme.palette.primary.main,
        fontStyle: 'bold',
    },
    padding: {
        //whiteSpace: "pre" as "pre",
        paddingLeft: "7px",

        //"@media (max-width: 600px)": {
        //    fontSize: "0.95rem",
        //},
    },
    primaryTextField: {
        color: theme.palette.primary.main,
        backgroundColor: "inherit",
        textAlign: 'left' as 'left',
    },
    gutterBottom: {
        marginBottom: '0.35em',
    },
    dialogContent: {
        paddingBottom: '14px'
    }
});

const mapStateToProps = (state: AppState) => ({
    userData: state.pageState.userData
});

export default connect(mapStateToProps)(withStyles(styles)(ZamInfoError));